exports.components = {
  "component---src-pages-articles-jsx": () => import("./../../../src/pages/articles.jsx" /* webpackChunkName: "component---src-pages-articles-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-templates-article-post-jsx": () => import("./../../../src/templates/article-post.jsx" /* webpackChunkName: "component---src-templates-article-post-jsx" */)
}

